/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidSchemeModelSearchResultModel } from '../../models/medical-aid-scheme-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface MedicalAidMedicalAidIdSearchMedicalAidSchemePost$Params {
  medicalAidId: string;
      body?: SearchRequestModel
}

export function medicalAidMedicalAidIdSearchMedicalAidSchemePost(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidIdSearchMedicalAidSchemePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidSchemeModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidIdSearchMedicalAidSchemePost.PATH, 'post');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<MedicalAidSchemeModelSearchResultModel>;
    })
  );
}

medicalAidMedicalAidIdSearchMedicalAidSchemePost.PATH = '/MedicalAid/{medicalAidId}/SearchMedicalAidScheme';
